import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Button} from 'antd'

import style from './links.sass'

@inject('store') @observer
class Links extends Component {
  turnPaperTradingOn = () => {
    const algoId = this.props.store.backtest.single.algo.id
    this.props.store.paperTrading.turnOn({algoId})
  }
  editAlgo = async () => {
    const store = this.props.store
    await store.backtest.editAlgo()
    this.props.openEditor()
  }
  render() {
    const {backtest, paperTrading} = this.props.store
    const {algo, data} = backtest.single
    const paperDisabled = !this.props.store.permissions.check('account.paper_trading.enable')

    if (algo.has_active_trading_sessions) {
      return(
        <div styleName='wrapper'>
          <Link to={`/manager/paper-trading/${algo.active_trading_session.id}`}>
            <Button type='primary'>
              View Paper Trading
            </Button>
          </Link>
        </div>
      )
    } else {
      return(
        <div styleName='wrapper'>
          <Button
            type='primary'
            onClick={this.turnPaperTradingOn}
            loading={paperTrading.turningOn}
            disabled={data.is_currently_running || paperDisabled}
          >
            Turn on Paper Trading
          </Button>
          {this.props.editor
            ? <Link to={`/builder/edit/${algo.id}`}>
              <Button
                type='primary'
                icon='edit'
                disabled={data.is_currently_running || paperTrading.turningOn}
              >
                Edit Entire Algo
              </Button>
            </Link>
            : <Button
              type='primary'
              icon='edit'
              onClick={!backtest.editingAlgo ? this.editAlgo : this.props.openEditor}
              disabled={data.is_currently_running || paperTrading.turningOn}
              loading={backtest.editingAlgoLoading}
            >
              Edit Algo
            </Button>
          }
        </div>
      )
    }
  }
}

export default Links
